import { create } from 'zustand';
import { DEFAULT_LOCALE } from '../i18n';

interface LocaleStoreState {
  locale: string;
  setLocale: (locale: string) => void;
}

export const useLocaleStore = create<LocaleStoreState>((set) => ({
  locale: DEFAULT_LOCALE,
  setLocale: (locale) => set({ locale }),
}));
